import { ResponseError } from "../clients/aggrego-proxy";
import { MovicodersExceptionBase } from "../domain/model/MovicodersExceptionBase";

export const handleError = async (error?: ResponseError): Promise<MovicodersExceptionBase | undefined> =>
  error?.response?.json() ?? ({ timestamp: Date.now(), errors: [] } as MovicodersExceptionBase);
